/**
 * Brand Day member status flow
 * 用途: 查询邮箱注册/订阅状态，并在独立 DSM Dialog 中处理订阅或快捷注册
 * 依赖: window.__MC__CONFIG__, window.DsmDialog, window.DsmToast
 */
;(function () {
  'use strict'

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  function getConfig() {
    return window.__MC__CONFIG__ || {}
  }

  function normalizeResult(json) {
    if (!json || typeof json !== 'object') return {}
    return json.result || json.data || json
  }

  function getErrorMessage(json, fallback) {
    return (json && (json.message || json.msg)) || fallback
  }

  function isMemberFlag(value) {
    return value === true || value === 1 || value === '1' || value === 'true'
  }

  function isFailure(response, json, result, acceptedCodes) {
    if (!response.ok) return true
    if (typeof result.registered === 'boolean' || typeof result.subscribed === 'boolean') return false
    if (json && json.code !== undefined) {
      var code = String(json.code)
      return ['0', '200'].indexOf(code) === -1 && (acceptedCodes || []).indexOf(code) === -1
    }
    return false
  }

  async function request(path, body, options) {
    var config = getConfig()
    var response = await fetch((config.apiUrl || '') + path, {
      method: 'POST',
      headers: Object.assign(
        { 'Content-Type': 'application/json' },
        config.headers || {}
      ),
      credentials: 'include',
      body: JSON.stringify(body || {})
    })
    var json = await response.json().catch(function () { return {} })
    var result = normalizeResult(json)
    if (isFailure(response, json, result, options && options.acceptedCodes)) {
      throw new Error(getErrorMessage(json, 'Unable to complete your request. Please try again.'))
    }
    return result
  }

  async function getPrivacyVersion() {
    var config = getConfig()
    try {
      var response = await fetch(
        (config.apiUrl || '') + '/api/station/user/get/privacyPolicy?protocolType=1&client=1&countryCode=US',
        {
          method: 'GET',
          headers: Object.assign({}, config.headers || {}),
          credentials: 'include'
        }
      )
      var json = await response.json()
      var result = normalizeResult(json)
      return result.versionNumber || ''
    } catch (error) {
      return ''
    }
  }

  async function assignCustomerTag(email, tagValue, sceneId) {
    var tag = (tagValue || '').trim()
    if (!tag) return

    var config = getConfig()
    var params = [
      'email=' + encodeURIComponent(email),
      'scene=' + encodeURIComponent(sceneId || '4'),
      'reSubmittable=1',
      'tagValue=' + encodeURIComponent(tag)
    ]
    var response = await fetch(
      (config.apiUrl || '') + '/api/station/activity/collectEmail?' + params.join('&'),
      {
        method: 'GET',
        headers: Object.assign({}, config.headers || {}),
        credentials: 'include'
      }
    )
    var json = await response.json().catch(function () { return {} })
    var code = json && json.code !== undefined ? String(json.code) : ''
    if (!response.ok || (code && code !== '0' && code !== '200')) {
      throw new Error(getErrorMessage(json, 'Unable to apply your member reward. Please try again.'))
    }
  }

  function setButtonLoading(button, loading) {
    if (!button) return
    button.classList.toggle('is-loading', loading)
    button.setAttribute('aria-busy', loading ? 'true' : 'false')
  }

  function setButtonDisabled(button, disabled) {
    if (!button) return
    button.disabled = disabled
    button.classList.toggle('dsm-btn--disabled', disabled)
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false')
  }

  function showToast(message, tone) {
    if (window.DsmToast && typeof window.DsmToast.show === 'function') {
      var toastId = window.DsmToast.show({
        message: message,
        tone: tone || 'success',
        placement: 'top-center'
      })
      var toast = document.getElementById('dsm-toast-' + toastId)
      if (toast) toast.classList.add('yg-brand-day-toast--viewport-center')
      return
    }
    window.alert(message)
  }

  function init(root) {
    if (!root || root.dataset.ygMemberStatusReady === 'true') return
    root.dataset.ygMemberStatusReady = 'true'

    var dialogId = root.dataset.dialogId
    var form = root.querySelector('[data-yg-member-status-form]')
    var input = root.querySelector('[data-yg-member-email]')
    var formButton = root.querySelector('[data-yg-member-status-submit]')
    var formError = root.querySelector('[data-yg-member-form-error]')
    var overlay = document.querySelector('[data-dsm-dialog="' + dialogId + '"]')
    if (!form || !input || !formButton || !overlay) return
    overlay.removeAttribute('hidden')

    var dialog = overlay.querySelector('[data-yg-member-status-dialog]')
    var dialogError = overlay.querySelector('[data-yg-member-dialog-error]')
    var currentEmail = ''
    var currentState = ''

    function clearError(target) {
      target.hidden = true
      target.textContent = ''
    }

    function showError(target, message) {
      target.textContent = message
      target.hidden = false
    }

    function getState(registered, subscribed) {
      if (registered && subscribed) return 'registered-subscribed'
      if (registered) return 'registered-unsubscribed'
      if (subscribed) return 'unregistered-subscribed'
      return 'unregistered-unsubscribed'
    }

    async function getMemberStatus(email) {
      return request('/api/station/user/email/status', { email: email })
    }

    async function waitForMemberStatus(email, expectedRegistered, expectedSubscribed) {
      var lastStatus = {}
      for (var attempt = 0; attempt < 3; attempt += 1) {
        lastStatus = await getMemberStatus(email)
        var registered = isMemberFlag(lastStatus.registered)
        var subscribed = isMemberFlag(lastStatus.subscribed)
        var registeredMatches = expectedRegistered === null || registered === expectedRegistered
        var subscribedMatches = expectedSubscribed === null || subscribed === expectedSubscribed
        if (registeredMatches && subscribedMatches) return lastStatus
        if (attempt < 2) {
          await new Promise(function (resolve) { window.setTimeout(resolve, 400) })
        }
      }
      throw new Error(lastStatus.message || 'Your member preferences could not be confirmed. Please try again.')
    }

    function updateActionLabel() {
      var state = dialog.querySelector('[data-yg-member-state="unregistered-unsubscribed"]')
      var registerChoice = state.querySelector('[data-yg-member-register]')
      var button = state.querySelector('[data-yg-member-action]')
      var label = button && button.querySelector('.dsm-btn__label')
      if (label) {
        label.textContent = registerChoice.checked
          ? dialog.dataset.subscribeRegisterLabel
          : dialog.dataset.subscribeLabel
      }
    }

    function showState(stateName) {
      currentState = stateName
      var activeState = null
      dialog.querySelectorAll('[data-yg-member-state]').forEach(function (state) {
        state.hidden = state.dataset.ygMemberState !== stateName
        if (!state.hidden) activeState = state
      })
      var activeTitle = activeState && activeState.querySelector('.yg-member-status-dialog__title')
      overlay.removeAttribute('aria-labelledby')
      overlay.setAttribute('aria-label', activeTitle ? activeTitle.textContent.trim() : 'Momcozy member status')
      dialog.querySelectorAll('[data-yg-member-dialog-email]').forEach(function (emailField) {
        emailField.value = currentEmail
      })
      var firstSubscribe = dialog.querySelector('[data-yg-member-subscribe]')
      var firstRegister = dialog.querySelector('[data-yg-member-register]')
      var registerOnly = dialog.querySelector('[data-yg-member-register-only]')
      if (firstSubscribe) firstSubscribe.checked = true
      if (firstRegister) firstRegister.checked = false
      if (registerOnly) registerOnly.checked = false
      var registerButton = dialog.querySelector('[data-yg-member-action="register"]')
      var subscribeButton = dialog.querySelector('[data-yg-member-action="subscribe-or-register"]')
      setButtonDisabled(registerButton, true)
      setButtonDisabled(subscribeButton, false)
      updateActionLabel()
      clearError(dialogError)
      if (window.DsmDialog) window.DsmDialog.open(dialogId)
    }

    async function subscribe(email) {
      return request('/api/station/user/subscribe', { email: email })
    }

    async function quickRegister(email, subscribeNews) {
      var registrationParamName = (root.dataset.registrationParamName || 'source').trim()
      var registrationParamValue = root.dataset.registrationParamValue || 'QuickRegistration_26BrandDay'
      var privacyVersion = await getPrivacyVersion()
      var requestBody = {
        email: email,
        platForm: 'SHOPIFY',
        registerChannel: 'shopify_web',
        redirect: window.location.href,
        agreePrivacyCountryCode: 'US',
        agreePrivacyVersion: privacyVersion
      }
      if (subscribeNews) requestBody.subscribeNews = 1
      requestBody[registrationParamName || 'source'] = registrationParamValue
      var pendingActivationCodes = ['10004007', '10004050']
      var result = await request('/api/station/user/quick/register', requestBody, {
        acceptedCodes: pendingActivationCodes
      })
      var resultCode = result && result.code !== undefined ? String(result.code) : ''
      if (
        result.isRegister !== undefined &&
        Number(result.isRegister) !== 1 &&
        pendingActivationCodes.indexOf(resultCode) === -1
      ) {
        throw new Error(result.message || 'Unable to create this membership. Please try again.')
      }
      return result
    }

    function getActionTag(action, subscribeNews) {
      if (action === 'register') return root.dataset.registerTag
      if (action === 'subscribe') return root.dataset.subscribeTag
      return subscribeNews ? root.dataset.registerSubscribeTag : root.dataset.subscribeTag
    }

    async function handleAction(button) {
      if (button.classList.contains('is-loading')) return
      clearError(dialogError)
      var action = button.dataset.ygMemberAction
      var subscribeNews = false

      if (action === 'subscribe-or-register') {
        var state = button.closest('[data-yg-member-state]')
        var subscribeChoice = state.querySelector('[data-yg-member-subscribe]')
        var registerChoice = state.querySelector('[data-yg-member-register]')
        if (!subscribeChoice.checked) {
          showError(dialogError, 'Please select the subscription option to continue.')
          return
        }
        subscribeNews = currentState === 'unregistered-unsubscribed' && registerChoice.checked
      }

      if (action === 'register') {
        var registerOnly = button.closest('[data-yg-member-state]').querySelector('[data-yg-member-register-only]')
        if (!registerOnly.checked) return
      }

      setButtonLoading(button, true)
      try {
        var successMessage = dialog.dataset.successMessage || 'Your member preferences have been updated.'
        if (action === 'subscribe') {
          await subscribe(currentEmail)
          await waitForMemberStatus(currentEmail, currentState === 'registered-unsubscribed', true)
        } else if (action === 'register') {
          await quickRegister(currentEmail)
          // 快捷注册会发送初始密码邮件；账号完成邮件激活前，状态接口仍会返回未注册。
          successMessage = dialog.dataset.registrationSuccessMessage || successMessage
        } else if (subscribeNews) {
          await quickRegister(currentEmail, true)
          // subscribeNews=1 会同时完成订阅，但不应等待邮件激活后的注册状态。
          await waitForMemberStatus(currentEmail, null, true)
          successMessage = dialog.dataset.registrationSuccessMessage || successMessage
        } else {
          await subscribe(currentEmail)
          await waitForMemberStatus(currentEmail, false, true)
        }
        await assignCustomerTag(currentEmail, getActionTag(action, subscribeNews), root.dataset.tagSceneId)
        window.DsmDialog.close(dialogId)
        showToast(successMessage, 'success')
      } catch (error) {
        showError(dialogError, error.message || 'Unable to complete your request. Please try again.')
      } finally {
        setButtonLoading(button, false)
      }
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault()
      if (formButton.classList.contains('is-loading')) return
      clearError(formError)
      currentEmail = input.value.trim().toLowerCase()
      if (!EMAIL_RE.test(currentEmail)) {
        showError(formError, 'Please enter a valid email address.')
        input.focus()
        return
      }
      if (window.luteTrack) {
        window.luteTrack("event:join-now:complete-registration")
      }

      setButtonLoading(formButton, true)
      try {
        var result = await getMemberStatus(currentEmail)
        var state = getState(isMemberFlag(result.registered), isMemberFlag(result.subscribed))
        if (state === 'registered-subscribed') {
          await assignCustomerTag(currentEmail, root.dataset.existingMemberTag, root.dataset.tagSceneId)
        }
        showState(state)
      } catch (error) {
        showError(formError, error.message || 'Unable to check this email. Please try again.')
      } finally {
        setButtonLoading(formButton, false)
      }
    })

    overlay.addEventListener('change', function (event) {
      if (event.target.matches('[data-yg-member-register]')) updateActionLabel()
      if (event.target.matches('[data-yg-member-register-only]')) {
        setButtonDisabled(dialog.querySelector('[data-yg-member-action="register"]'), !event.target.checked)
      }
      if (event.target.matches('[data-yg-member-subscribe]')) {
        var subscribeButton = dialog.querySelector('[data-yg-member-action="subscribe-or-register"]')
        setButtonDisabled(subscribeButton, !event.target.checked)
        if (event.target.checked) clearError(dialogError)
      }
    })

    overlay.addEventListener('click', function (event) {
      var button = event.target.closest('[data-yg-member-action]')
      if (!button || button.disabled || button.classList.contains('is-loading')) return
      event.preventDefault()
      handleAction(button)
    })
  }

  function initAll(container) {
    ;(container || document).querySelectorAll('[data-yg-member-status-root]').forEach(init)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document) })
  } else {
    initAll(document)
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target) })
})()
